import styled from "styled-components";

export const Userarea = styled.div`
  text-align: right;
`;

export const Welcomemessage = styled.div`
  font-weight: 900;
  font-size: 12px;
  color: #0075bc;
  font-family: "BukraAlt_Bold";
`;
